<template>
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#6jts2jmqza)" fill="#1A202C">
      <path
        opacity=".2"
        d="M25 1.042c-.517 0-1.035.129-1.502.384l-18.75 9.37a3.132 3.132 0 0 0-1.623 2.746c0 21.875 4.627 27.575 20.313 35.077a3.13 3.13 0 0 0 3.002 0c15.686-7.502 18.352-13.202 18.352-35.077a3.132 3.132 0 0 0-1.624-2.747L26.502 1.426A3.126 3.126 0 0 0 25 1.042zm-1.042 8.333v31.25C14.271 37.5 9.375 32.745 9.375 17.708a2.15 2.15 0 0 1 1.117-1.886l13.466-6.447z"
      />
      <path
        d="M25-.008c-.69 0-1.38.171-2.002.513l.033-.02L4.28 9.862a4.172 4.172 0 0 0-2.197 3.678c0 11.013 1.167 18.102 4.459 23.438 3.284 5.323 8.591 8.71 16.455 12.476h.004a4.17 4.17 0 0 0 3.996 0h.004c7.877-3.773 12.707-7.204 15.454-12.545 2.754-5.355 3.377-12.39 3.377-23.368a4.172 4.172 0 0 0-2.152-3.654l-.008-.004L27.014.509l-.012-.004A4.167 4.167 0 0 0 25-.008zm0 2.083c.345 0 .69.086 1.001.257l16.654 9.37.013.009a2.092 2.092 0 0 1 1.082 1.83c0 10.897-.68 17.612-3.15 22.413-2.468 4.8-6.774 7.932-14.546 11.65a1.102 1.102 0 0 0-.053.024 2.09 2.09 0 0 1-2.002 0 1.102 1.102 0 0 0-.053-.025c-7.788-3.724-12.656-6.9-15.629-11.718-2.973-4.82-4.15-11.48-4.15-22.343a2.092 2.092 0 0 1 1.082-1.831l18.718-9.363.032-.016c.31-.17.656-.257 1.001-.257zm-.968 6.262c-.175-.012-.35.02-.51.094l-13.54 6.25a.978.978 0 0 0-.066.029c-1.183.648-1.585 1.898-1.583 2.998 0 7.624 1.162 12.66 3.736 16.293 2.573 3.632 6.454 5.7 11.523 7.6A1.042 1.042 0 0 0 25 40.626V9.375a1.042 1.042 0 0 0-.968-1.038zm-1.115 2.666v27.986c-4.081-1.66-7.182-3.413-9.152-6.193-2.218-3.13-3.348-7.675-3.348-15.088-.001-.467.308-1.062.5-1.167l12-5.538z"
      />
    </g>
    <defs>
      <clipPath id="6jts2jmqza">
        <path fill="#fff" d="M0 0h50v50H0z" />
      </clipPath>
    </defs>
  </svg>
</template>
